class StreamReader {
  read(file) {
    return new Promise((resolve, reject) => {
      try {
        const url = URL.createObjectURL(file);
        resolve(url);
      } catch (e) {
        reject(e);
      }
    });
  }
  free(url) {
    URL.revokeObjectURL(url);
  }
}

export { StreamReader };
//# sourceMappingURL=StreamReader.js.map
